<template>
    <div v-if="isLoadingScreen" class="fixed inset-0 flex items-center justify-center bg-black z-50">
        <div role="status">
            <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor" />
                <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill" />
            </svg>
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="p-4 sm:ml-64">
        <div class="p-4">
            <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
                <div class="grid gap-6 mb-6 md:grid-cols-2">
                    <nav class="flex" aria-label="Breadcrumb">
                        <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                            <li class="inline-flex items-center">
                                <a href="#"
                                    class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
                                    <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor" viewBox="0 0 20 20">
                                        <path
                                            d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
                                    </svg>
                                    {{ breadCrumb.root.text }}
                                </a>
                            </li>
                            <li v-for="items in breadCrumb.child" :key="items.text">
                                <div class="flex items-center">
                                    <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" d="m1 9 4-4-4-4" />
                                    </svg>
                                    <a href="#"
                                        class="ms-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white">{{
                                            items.text
                                        }}</a>
                                </div>
                            </li>
                        </ol>
                    </nav>
                    <div class="flex justify-end">
                        <button @click="create"
                            class="bg-blue-700 text-white px-2 py-1 rounded-md shadow-md hover:bg-gray-700 transition-colors duration-300">
                            <svg class="w-6 h-6 text-white-800 dark:text-white" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                viewBox="0 0 24 24">
                                <path fill-rule="evenodd"
                                    d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v6.41A7.5 7.5 0 1 0 10.5 22H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Z"
                                    clip-rule="evenodd" />
                                <path fill-rule="evenodd"
                                    d="M9 16a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
                                    clip-rule="evenodd" />
                            </svg>

                        </button>
                    </div>

                    <div class="justify-start">
                        <form @submit.prevent="searchData">
                            <div class="flex">
                                <div class="relative w-full">
                                    <input v-model="search" type="search" id="search-dropdown"
                                        class="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-s-lg rounded-e-lg  border-s-1 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                                        placeholder="Search..." required />
                                    <button type="submit"
                                        class="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-blue-700 rounded-e-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                        <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                            fill="none" viewBox="0 0 20 20">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                        </svg>
                                        <span class="sr-only">Search</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <button @click="reset"
                        class="max-w-10 bg-blue-700 text-white px-2 py-1 rounded-md shadow-md hover:bg-gray-700 transition-colors duration-300">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                        </svg>
                    </button>
                </div>

                <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" class="px-6 py-3">
                                    Title
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    TYPE
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    Start Date
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    End Date
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    Publish
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    Banner
                                </th>
                                <th scope="col" class="px-2 py-3">
                                    Banner Mobile
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    Thumbnail
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    Created By
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    Updated By
                                </th>
                                <th scope="col" class="px-6 py-3">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :class="{ 'bg-red-500 text-white': !item.publish, 'bg-white dark:bg-gray-800': item.publish }"
                                v-for="item in getListProduk.content" :key="item.id">
                                <td scope="row" class="px-6 py-4 font-mediu text-warp dark:text-white">
                                    {{ item.judulProduk }}
                                </td>
                                <td class="px-6 py-4">
                                    <span v-if="item.promo">
                                        PROMO
                                    </span>
                                    <span v-else>
                                        NOT PROMO
                                    </span>
                                </td>
                                <td class="px-6 py-4">
                                    {{ formatDate(item.startDate) }}
                                </td>
                                <td class="px-6 py-4 ">
                                    <span v-if="item.promo">
                                        {{ formatDate(item.endDate) }}
                                    </span>
                                </td>
                                <td class="px-6 py-4 ">
                                    <span v-if="item.publish">
                                        PUBLISH
                                    </span>
                                    <span v-else>
                                        NOT PUBLISH
                                    </span>
                                </td>
                                <td class="px-2 py-4">
                                    <button @click="openModalImage(item.id, item.bannerProduk)"
                                        class="block text-white bg-white-700  font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                        type=" button">
                                        <svg class="w-6 h-6 text-blue-800 dark:text-white" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            fill="currentColor" viewBox="0 0 24 24">
                                            <path fill-rule="evenodd"
                                                d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-7Zm.394 9.553a1 1 0 0 0-1.817.062l-2.5 6A1 1 0 0 0 8 19h8a1 1 0 0 0 .894-1.447l-2-4A1 1 0 0 0 13.2 13.4l-.53.706-1.276-2.553ZM13 9.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                    <!-- Main modal -->
                                    <div class="fixed inset-0 bg-black z-50" v-if="isModalImageOpen">
                                        <div aria-hidden="true" class="fixed inset-0 flex items-center justify-center">
                                            <div class="relative p-4 ">
                                                <!-- Modal content -->
                                                <div class="relative bg-white rounded-lg shadow">
                                                    <!-- Modal header -->
                                                    <div
                                                        class="flex items-center justify-between p-4 border-b rounded-t">
                                                        <h3 class="text-xl font-semibold text-gray-900">Banner (1064 x
                                                            260 Pixels)</h3>
                                                        <button type="button" @click="closeModalImage"
                                                            class="text-gray-400 bg-transparent rounded-lg w-8 h-8">
                                                            <svg class="w-3 h-3" aria-hidden="true" fill="none"
                                                                viewBox="0 0 14 14">
                                                                <path stroke="currentColor" stroke-linecap="round"
                                                                    stroke-linejoin="round" stroke-width="2"
                                                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                                            </svg>
                                                            <span class="sr-only">Close modal</span>
                                                        </button>
                                                    </div>
                                                    <!-- Modal body -->
                                                    <div class="p-4 space-y-4">
                                                        <div>
                                                            <div class="max-h-full">
                                                                <label class="cursor-pointer">
                                                                    <div v-if="isLoading"
                                                                        class="flex items-center justify-center w-full h-32">
                                                                        <svg class="animate-spin h-10 w-10 text-gray-500"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            fill="none" viewBox="0 0 24 24">
                                                                            <circle class="opacity-25" cx="12" cy="12"
                                                                                r="10" stroke="currentColor"
                                                                                stroke-width="4"></circle>
                                                                            <path class="opacity-75" fill="currentColor"
                                                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A8.001 8.001 0 0112 4v4a4 4 0 00-4 4H6v4.291zM20 12a8 8 0 01-8 8v-4a4 4 0 004-4h4zm-2-5.709A8.001 8.001 0 0112 20V16a4 4 0 004-4h4V6.291z">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                    <img v-else class="w-[1064px] h-[260px]  rounded-lg"
                                                                        :src="url_image" alt="image description">
                                                                    <input accept="image/png, image/jpeg"
                                                                        @change="onFileSelectedImage" type="file"
                                                                        class="hidden" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Modal footer -->
                                                    <div class="flex items-center p-4 border-t rounded-b">
                                                        <span v-if="this.imageUpload !== null">
                                                            <button @click="editGambar" type="button"
                                                                class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                                                Update
                                                            </button>
                                                        </span>
                                                        <span v-else>
                                                            <button disabled="true" type="button"
                                                                class="text-white bg-gray-400 hover:bg-gray-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-gray-400 dark:hover:bg-gray-400 dark:focus:ring-gray-400">
                                                                Update
                                                            </button>
                                                        </span>
                                                        <button type="button" @click="closeModalImage"
                                                            class="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                                                            Decline
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class="px-2">
                                    <button @click="openModalMobileImage(item.id, item.bannerMobileProduk)"
                                        class="block text-white bg-white-700  font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                        type=" button">
                                        <svg class="w-6 h-6 text-blue-800 dark:text-white" aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            fill="currentColor" viewBox="0 0 24 24">
                                            <path fill-rule="evenodd"
                                                d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-7Zm.394 9.553a1 1 0 0 0-1.817.062l-2.5 6A1 1 0 0 0 8 19h8a1 1 0 0 0 .894-1.447l-2-4A1 1 0 0 0 13.2 13.4l-.53.706-1.276-2.553ZM13 9.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </button>
                                    <!-- Main modal -->
                                    <div class="fixed inset-0 bg-black z-50" v-if="isModalMobileImageOpen">
                                        <div aria-hidden="true" class="fixed inset-0 flex items-center justify-center">
                                            <div class="relative p-4 ">
                                                <!-- Modal content -->
                                                <div class="relative bg-white rounded-lg shadow">
                                                    <!-- Modal header -->
                                                    <div
                                                        class="flex items-center justify-between p-4 border-b rounded-t">
                                                        <h3 class="text-xl font-semibold text-gray-900">Banner Mobile
                                                            (328 x
                                                            328 Pixels)</h3>
                                                        <button type="button" @click="closeModalMobileImage"
                                                            class="text-gray-400 bg-transparent rounded-lg w-8 h-8">
                                                            <svg class="w-3 h-3" aria-hidden="true" fill="none"
                                                                viewBox="0 0 14 14">
                                                                <path stroke="currentColor" stroke-linecap="round"
                                                                    stroke-linejoin="round" stroke-width="2"
                                                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                                            </svg>
                                                            <span class="sr-only">Close modal</span>
                                                        </button>
                                                    </div>
                                                    <!-- Modal body -->
                                                    <div class="p-4 space-y-4">
                                                        <div>
                                                            <div class="max-h-full">
                                                                <label class="cursor-pointer">
                                                                    <div v-if="isLoading"
                                                                        class="flex items-center justify-center w-full h-32">
                                                                        <svg class="animate-spin h-10 w-10 text-gray-500"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            fill="none" viewBox="0 0 24 24">
                                                                            <circle class="opacity-25" cx="12" cy="12"
                                                                                r="10" stroke="currentColor"
                                                                                stroke-width="4"></circle>
                                                                            <path class="opacity-75" fill="currentColor"
                                                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A8.001 8.001 0 0112 4v4a4 4 0 00-4 4H6v4.291zM20 12a8 8 0 01-8 8v-4a4 4 0 004-4h4zm-2-5.709A8.001 8.001 0 0112 20V16a4 4 0 004-4h4V6.291z">
                                                                            </path>
                                                                        </svg>
                                                                    </div>
                                                                    <img v-else class="w-[328px] h-[328px]  rounded-lg"
                                                                        :src="url_image" alt="image description">
                                                                    <input accept="image/png, image/jpeg"
                                                                        @change="onFileSelectedMobileImage" type="file"
                                                                        class="hidden" />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- Modal footer -->
                                                    <div class="flex items-center p-4 border-t rounded-b">
                                                        <span v-if="this.imageUploadMobile !== null">
                                                            <button @click="editGambarMobile" type="button"
                                                                class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                                                Update
                                                            </button>
                                                        </span>
                                                        <span v-else>
                                                            <button disabled="true" type="button"
                                                                class="text-white bg-gray-400 hover:bg-gray-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-gray-400 dark:hover:bg-gray-400 dark:focus:ring-gray-400">
                                                                Update
                                                            </button>
                                                        </span>
                                                        <button type="button" @click="closeModalMobileImage"
                                                            class="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                                                            Decline
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td class=" px-6 py-4">
                                    <span>
                                        <button @click="editThumbnail(item.id, item.judulProduk)"
                                            class="block text-white bg-white-700  font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                            type=" button">
                                            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                fill="currentColor" viewBox="0 0 24 24">
                                                <path fill-rule="evenodd"
                                                    d="M18 3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1V9a4 4 0 0 0-4-4h-3a1.99 1.99 0 0 0-1 .267V5a2 2 0 0 1 2-2h7Z"
                                                    clip-rule="evenodd" />
                                                <path fill-rule="evenodd"
                                                    d="M8 7.054V11H4.2a2 2 0 0 1 .281-.432l2.46-2.87A2 2 0 0 1 8 7.054ZM10 7v4a2 2 0 0 1-2 2H4v6a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3Z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                    </span>
                                </td>
                                <td class="px-6 py-4">
                                    {{ item.createdBy }}
                                </td>
                                <td class="px-6 py-4">
                                    {{ item.updatedBy }}
                                </td>
                                <td class="flex px-6 py-4">
                                    <span class="mr-2">
                                        <button @click="edit(item.id)"
                                            class="block text-white bg-white-700  font-medium rounded-lg text-sm py-2.5 text-center"
                                            type=" button">
                                            <span>
                                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    fill="currentColor" viewBox="0 0 24 24">
                                                    <path fill-rule="evenodd"
                                                        d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                                                        clip-rule="evenodd" />
                                                    <path fill-rule="evenodd"
                                                        d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                                                        clip-rule="evenodd" />
                                                </svg>
                                            </span>
                                        </button>
                                    </span>
                                    <span>
                                        <button @click="setPublishStatus(item.id, item.publish)"
                                            class="block text-white bg-white-700  font-medium rounded-lg text-sm py-2.5 text-center"
                                            type=" button">
                                            <span v-if="item.publish">
                                                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    fill="none" viewBox="0 0 24 24">
                                                    <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                                                        d="m6 6 12 12m3-6a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                </svg>
                                            </span>
                                            <span v-else>
                                                <span>
                                                    <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                                                        height="24" fill="currentColor" viewBox="0 0 24 24">
                                                        <path fill-rule="evenodd"
                                                            d="M12 2c-.791 0-1.55.314-2.11.874l-.893.893a.985.985 0 0 1-.696.288H7.04A2.984 2.984 0 0 0 4.055 7.04v1.262a.986.986 0 0 1-.288.696l-.893.893a2.984 2.984 0 0 0 0 4.22l.893.893a.985.985 0 0 1 .288.696v1.262a2.984 2.984 0 0 0 2.984 2.984h1.262c.261 0 .512.104.696.288l.893.893a2.984 2.984 0 0 0 4.22 0l.893-.893a.985.985 0 0 1 .696-.288h1.262a2.984 2.984 0 0 0 2.984-2.984V15.7c0-.261.104-.512.288-.696l.893-.893a2.984 2.984 0 0 0 0-4.22l-.893-.893a.985.985 0 0 1-.288-.696V7.04a2.984 2.984 0 0 0-2.984-2.984h-1.262a.985.985 0 0 1-.696-.288l-.893-.893A2.984 2.984 0 0 0 12 2Zm3.683 7.73a1 1 0 1 0-1.414-1.413l-4.253 4.253-1.277-1.277a1 1 0 0 0-1.415 1.414l1.985 1.984a1 1 0 0 0 1.414 0l4.96-4.96Z"
                                                            clip-rule="evenodd" />
                                                    </svg>
                                                </span>
                                            </span>
                                        </button>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <nav class="flex items-center flex-column flex-wrap md:flex-row justify-between pt-4"
                    aria-label="Table navigation">
                    <span
                        class="text-sm font-normal text-gray-500 dark:text-gray-400 mb-4 md:mb-0 block w-full md:inline md:w-auto">Showing
                        <span class="font-semibold text-gray-900 dark:text-white">
                            {{ (pageInfo.pageNumber - 1) * pageInfo.pageSize + 1 }} -
                            {{ Math.min(pageInfo.pageNumber * pageInfo.pageSize, pageInfo.totalElements) }}
                        </span> of <span class="font-semibold text-gray-900 dark:text-white">{{ pageInfo.totalElements
                            }}</span></span>
                    <ul class="inline-flex -space-x-px rtl:space-x-reverse text-sm h-8">
                        <li v-if="this.pageInfo.pageNumber > 1"> <a href="#" @click="goToPreviousPage"
                                class="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                                Previous</a>
                        </li>
                        <li v-for="pageNumber in visiblePages" :key="pageNumber">
                            <a href="#" aria-current="page" @click="goToPage(pageNumber)"
                                :class="{ 'bg-blue-700 text-white': pageNumber === pageInfo.pageNumber }"
                                class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">{{
                                    pageNumber }}</a>
                        </li>
                        <li>
                            <a href="#" @click="goToNextPage"
                                class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">Next</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import image1 from '@/assets/image-1@2x.jpg'
import { format } from 'date-fns'
import { id } from 'date-fns/locale'

export default {
    data() {
        return {
            url_image: require("@/assets/image-1@2x.jpg"),
            isModalImageOpen: false,
            isModalMobileImageOpen: false,
            isLoading: false,
            isLoadingScreen: false,
            clickedItemId: null,
            imageUpload: null,
            imageUploadMobile: null,
            search: "",
            agensi: null,
            breadCrumb: {
                root: { text: "Home", url: "" },
                child: [
                    { text: "Produk", url: "" },
                    { text: "List", url: "" }
                ]
            },
            pageInfo: {
                totalPages: 0,
                pageNumber: 0,
                visiblePages: 5,
                pageSize: 5,
                totalElements: 0,
                isSearch: false,
            }
        }
    },
    created() {
        var parameters = this.$route.params
        this.fetchData(parameters.agensi, parseInt(parameters.pageNumber), parameters.isSearch, parameters.search)
    },
    computed: {
        getListProduk() {
            return this.$store.getters.getListProduk
        },
        visiblePages() {
            const activePage = this.pageInfo.pageNumber;
            const totalVisiblePages = this.pageInfo.visiblePages;
            const totalPages = this.pageInfo.totalPages;

            let startPage = activePage - Math.floor(totalVisiblePages / 2)
            startPage = Math.max(startPage, 1)
            let endPage = startPage + totalVisiblePages - 1
            endPage = Math.min(endPage, totalPages)

            if (endPage === totalPages && totalPages - totalVisiblePages + 1 > 0) {
                startPage = totalPages - totalVisiblePages + 1
            }

            let visiblePages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)

            if (endPage < totalPages) {
                visiblePages.push(endPage + 1)
            }

            return visiblePages;
        }
    },
    methods: {
        formatDate(date) {
            return format(new Date(date), 'EEEE, dd MMMM yyyy', { locale: id });
        },
        async fetchData(agensi, pageNumber, isSearch, search) {
            this.pageInfo.pageNumber = pageNumber
            this.pageInfo.isSearch = isSearch
            this.agensi = agensi
            await this.$store.dispatch('listProduk', {
                isSearch: this.pageInfo.isSearch,
                search: search,
                index: (this.pageInfo.pageNumber - 1),
                limit: this.pageInfo.pageSize,
            }).then(() => {
                this.isLoadingScreen = true
                this.pageInfo.totalElements = this.getListProduk.totalElements
                this.pageInfo.totalPages = this.getListProduk.totalPages
            }).finally(() => {
                this.isLoadingScreen = false
            })
        },
        async reset() {
            this.search = ""
            await this.fetchData(this.agensi, 1, false, this.search)
            this.tempRouteList(this.agensi, this.pageInfo.isSearch, this.pageInfo.pageNumber)
        },
        async searchData() {
            await this.fetchData(this.agensi, 1, true, this.search)
            this.tempRouteListSearch(this.agensi, this.pageInfo.isSearch, this.pageInfo.pageNumber, this.search)
        },
        async goToPage(pageNumber) {
            if (pageNumber >= 1 && pageNumber <= this.pageInfo.totalPages) {
                await this.fetchData(this.agensi, pageNumber, this.pageInfo.isSearch, this.search)
                if (this.pageInfo.isSearch === true) {
                    this.tempRouteListSearch(this.agensi, this.pageInfo.isSearch, pageNumber, this.search)
                } else {
                    this.tempRouteList(this.agensi, this.pageInfo.isSearch, pageNumber)
                }
            }
        },
        async goToNextPage() {
            const nextPageNumber = this.pageInfo.pageNumber + 1;
            if (nextPageNumber <= this.pageInfo.totalPages) {
                await this.fetchData(this.agensi, nextPageNumber, this.pageInfo.isSearch, this.search)
                if (this.pageInfo.isSearch === true) {
                    this.tempRouteListSearch(this.agensi, this.pageInfo.isSearch, nextPageNumber, this.search)
                } else {
                    this.tempRouteList(this.agensi, this.pageInfo.isSearch, nextPageNumber)
                }
            }
        },
        async goToPreviousPage() {
            const previousPageNumber = this.pageInfo.pageNumber - 1
            if (previousPageNumber >= 1) {
                await this.fetchData(this.agensi, previousPageNumber, this.pageInfo.isSearch, this.search);
                if (this.pageInfo.isSearch === true) {
                    this.tempRouteListSearch(this.agensi, this.pageInfo.isSearch, previousPageNumber, this.search)
                } else {
                    this.tempRouteList(this.agensi, this.pageInfo.isSearch, previousPageNumber)
                }
            }
        },
        tempRouteListSearch(agensi, isSearch, pageNumber, search) {
            this.$router.push({ name: 'list-produk-search', params: { agensi: agensi, isSearch: isSearch, pageNumber: pageNumber, search: search.replace(/\s+/g, '-') } })
        },
        tempRouteList(agensi, isSearch, pageNumber) {
            this.$router.push({ name: 'list-produk', params: { agensi: agensi, isSearch: isSearch, pageNumber: pageNumber } })
        },
        openModalImage(itemId, itemGambar) {
            this.clickedItemId = itemId
            this.isLoading = true
            this.url_image = itemGambar || null
            this.isModalImageOpen = true

            const imgElement = new Image()
            imgElement.src = itemGambar

            imgElement.addEventListener('load', () => {
                this.isLoading = false;
            })

            imgElement.addEventListener('error', () => {
                this.isLoading = false;
                console.error('Error loading image')
            })
        },
        closeModalImage() {
            this.isModalImageOpen = false
            this.imageUpload = null
            this.url_image = image1
        },
        onFileSelectedImage(event) {
            const inputElement = event.target
            const file = inputElement.files?.[0]
            this.url_image = file ? URL.createObjectURL(file) : ""
            this.imageUpload = file ? file : ""
        },
        editGambar() {
            if (this.imageUpload.size >= (100 * 1024)) {
                Swal.fire({
                    title: "Warning",
                    text: "File size should not exceed 100 KB",
                    icon: "warning"
                })
            } else {
                const image = new Image();
                image.src = URL.createObjectURL(this.imageUpload)
                image.onload = () => {
                    const width = image.naturalWidth
                    const height = image.naturalHeight

                    if (width !== 1064 || height !== 260) {
                        Swal.fire({
                            title: "Warning",
                            text: "Image dimensions should be 1064 x 260 pixels",
                            icon: "warning"
                        });
                    } else {
                        Swal
                            .fire({
                                title: "Are you sure?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes, Edit",
                            })
                            .then((result) => {
                                if (result.isConfirmed) {
                                    this.isLoading = true
                                    this.$store.dispatch('editBannerProduk', {
                                        id: this.clickedItemId,
                                        bannerProduk: this.imageUpload
                                    }).then(() => {
                                        Swal.fire({
                                            title: "Edit Success",
                                            text: "Sukses Edit Banner Produk!",
                                            icon: "success"
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                this.isLoading = false
                                                this.isModalImageOpen = false
                                                location.reload()
                                            }
                                        })
                                    }).catch((error) => {
                                        Swal.fire({
                                            title: "Error",
                                            text: "Gagal Edit Banner Produk: " + error,
                                            icon: "error"
                                        })
                                    })
                                }
                            })
                    }
                }
            }
        },
        openModalMobileImage(itemId, itemGambar) {
            console.log(itemGambar)
            this.clickedItemId = itemId
            this.isLoading = true
            if (itemGambar !== null) {
                this.url_image = itemGambar
            }
            this.isModalMobileImageOpen = true

            const imgElement = new Image()
            imgElement.src = itemGambar

            imgElement.addEventListener('load', () => {
                this.isLoading = false;
            })

            imgElement.addEventListener('error', () => {
                this.isLoading = false;
                console.error('Error loading image')
            })
        },
        closeModalMobileImage() {
            this.isModalMobileImageOpen = false
            this.imageUploadMobile = null
            this.url_image = image1
        },
        onFileSelectedMobileImage(event) {
            const inputElement = event.target
            const file = inputElement.files?.[0]
            this.url_image = file ? URL.createObjectURL(file) : ""
            this.imageUploadMobile = file ? file : ""
        },
        editGambarMobile() {
            if (this.imageUploadMobile.size >= (100 * 1024)) {
                Swal.fire({
                    title: "Warning",
                    text: "File size should not exceed 100 KB",
                    icon: "warning"
                })
            } else {
                const image = new Image();
                image.src = URL.createObjectURL(this.imageUploadMobile)
                image.onload = () => {
                    const width = image.naturalWidth
                    const height = image.naturalHeight

                    if (width !== 328 || height !== 328) {
                        Swal.fire({
                            title: "Warning",
                            text: "Image dimensions should be 328 x 328 pixels",
                            icon: "warning"
                        });
                    } else {
                        Swal
                            .fire({
                                title: "Are you sure?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes, Edit",
                            })
                            .then((result) => {
                                if (result.isConfirmed) {
                                    this.isLoading = true
                                    this.$store.dispatch('editBannerMobileProduk', {
                                        id: this.clickedItemId,
                                        bannerMobileProduk: this.imageUploadMobile
                                    }).then(() => {
                                        Swal.fire({
                                            title: "Edit Success",
                                            text: "Sukses Edit Banner Mobile Produk!",
                                            icon: "success"
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                this.isLoading = false
                                                this.isModalImageOpen = false
                                                location.reload()
                                            }
                                        })
                                    }).catch((error) => {
                                        Swal.fire({
                                            title: "Error",
                                            text: "Gagal Edit Banner Mobile Produk: " + error,
                                            icon: "error"
                                        })
                                    })
                                }
                            })
                    }
                }
            }
        },
        setPublishStatus(id, publish) {
            Swal
                .fire({
                    title: "Are you sure?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, Change",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.isLoadingScreen = true
                        this.$store.dispatch('setStatusPublishProduk', {
                            id: id,
                            publish: publish
                        }).then(() => {
                            Swal.fire({
                                title: "Success",
                                text: "Sukses Mengubah Status Publish Produk!",
                                icon: "success"
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.isLoadingScreen = false
                                    location.reload()
                                }
                            })
                        }).catch((error) => {
                            Swal.fire({
                                title: "Error",
                                text: "Gagal Mengubah Status Publish Produk: " + error,
                                icon: "error"
                            })
                        })
                    }
                })
        },
        create() {
            this.$router.push({ name: 'create-produk', params: { agensi: this.$route.params.agensi } })
        },
        edit(id) {
            this.$router.push({ name: 'edit-produk', params: { agensi: this.$route.params.agensi, idProduk: id } })
        },
        editThumbnail(id, namaProduk) {
            this.$router.push({ name: 'edit-thumbnail-produk', params: { agensi: this.$route.params.agensi, idProduk: id, namaProduk: namaProduk } })
        },
    }
}
</script>